<template>
    <div>
        <div v-if="showMessage">
            {{ message }}
        </div>
        <pc-alert
            v-if="showOpenTestEnvironmentWarning"
            v-bind="alertBinder">
            {{ testEnvironmentAlert }}
        </pc-alert>
    </div>
</template>
<script>
    import { ALERT_SEVERITY } from "Util/alerts";
    import { KEYS, NAMESPACE } from "./i18n/upgradeTemplateConfirmationDialog.i18n";
    import { mapI18n } from "Util/i18n";

    /**
     * @param {Boolean} isBulkUpgrade,
     * @param {Boolean} analyzeOnly
     */
    export function getConfirmUpgradeDialogTitle(isBulkUpgrade, analyzeOnly, $app) {
        // If not bulk upgrade, analyzeOnly can't be true because there's
        // no "analyze single" option
        if (!isBulkUpgrade) {
            return $app.res({
                namespace: NAMESPACE,
                key: KEYS.upgradeTitle
            });
        }

        return analyzeOnly
            ? $app.res({
                  namespace: NAMESPACE,
                  key: KEYS.analyzeAllTitle
              })
            : $app.res({
                  namespace: NAMESPACE,
                  key: KEYS.upgradeAllTitle
              });
    }

    export default {
        props: {
            isBulkUpgrade: { type: Boolean, required: false, default: false },
            analyzeOnly: { type: Boolean, required: false, default: false },
            isCommunicationTemplates: { type: Boolean, required: false, default: false },
            hasOpenTestEnvironment: { type: Boolean, required: false, default: false }
        },
        computed: {
            showMessage() {
                // We don't show a standard confirmation message if this is just a single
                // upgrade. In fact, we won't show this dialog at all unless we're showing
                // the "open test environment" warning
                return this.isBulkUpgrade;
            },
            showOpenTestEnvironmentWarning() {
                return this.hasOpenTestEnvironment && !this.analyzeOnly;
            },
            message() {
                const templateTypeStr = this.isCommunicationTemplates ? this.communicationType : this.documentType;

                return this.analyzeOnly
                    ? this.$app.res({
                          namespace: NAMESPACE,
                          key: KEYS.analyzeMessage,
                          values: { templateType: templateTypeStr }
                      })
                    : this.$app.res({
                          namespace: NAMESPACE,
                          key: KEYS.upgradeMessage,
                          values: { templateType: templateTypeStr }
                      });
            },
            alertBinder() {
                return {
                    shown: this.showOpenTestEnvironmentWarning,
                    severity: ALERT_SEVERITY.warning,
                    class: { "mb-0": true, "mt-3": this.showMessage }
                };
            },
            ...mapI18n(KEYS, NAMESPACE)
        }
    };
</script>
